// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createBasicWarrantyEstimator} from '../../shared/repositories';

export const createBasicWarrantyEstimatorReport = () =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const basicWarrantyEstimatorState = getState().reports.basicWarrantyEstimator;

        const reportCriteria = {
            dealers: basicWarrantyEstimatorState.selectedDealers,
            pin: basicWarrantyEstimatorState.criteria.pin
        };

        try {

            const data = await createBasicWarrantyEstimator(reportCriteria);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.CREATE_BASIC_WARRANTY_ESTIMATOR_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/action-creators/create-report.js